<template>
<div class="c-buffer-box c-buffer-box--vertical c-buffer-box--super-tight-top-ends t-border-green">
    <form @submit.prevent="handleSubmit" class="c-form c-competence-card-competence__form">
        <fieldset>
            <div class="o-grid o-grid--align-center">
                <div data-size="sm:12 md:8 lg:8" class="o-grid__column">
                    <dropdown-variations v-if="mode === 'create'" :item-groups="competenceOptions" label="Välj kompetensområde" :value="{id: id, name: name}" ref="competence" :allow-custom-value="true" :filterable="true"></dropdown-variations>
                    <div v-if="mode === 'edit'" class="c-form__item">
					    <vue-input label="Kompetens" :value="`${category}: ${name}`" disabled="disabled"></vue-input>
                    </div>
                </div>
                <div data-size="sm:11 md:3 lg:3" class="o-grid__column">
                    <dropdown-variations :item-groups="competenceLevelOptions" label="Välj kompetensnivå" :value="{id: level, name: level}" ref="level"></dropdown-variations>
                </div>
                <div data-size="sm:1 md:1 lg:1" class="o-grid__column">
                    <a href="#" class="c-competence-card-competence__levels c-form__item" @click="toggleLevelsModal">
                        <vue-icon name="info"></vue-icon>
                    </a>
                </div>
                <div data-size="sm:11 md:11 lg:11" class="o-grid__column">
                    <div class="c-form__item">
                        <vue-input label="Notering" :input-id="'note-'+id" :value="note" ref="note" :required="false"></vue-input>
                    </div>
                </div>
                <div data-size="sm:11 md:11 lg:11" class="o-grid__column">
                    <div class="c-form__item">
                        <vue-input
                            type="checkbox"
                            label="Visa på kompetenskort"
                            :inputId="`${'printOption-'+id}`"
                            :checked="(mode === 'create' || printOption === 'Display') ? 'checked' : null"
                            ref="printOption">
                        </vue-input>
                    </div>
                </div>
            </div>
            <div class="o-grid o-grid--align-center  t-margin-bottom-xs t-margin-top-s">
                <div data-size="sm:12 md:6 lg:6" class="o-grid__column">
                    <div class="t-text-align-left">
                        <button v-if="mode === 'edit'" type="submit" class="c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset" @click="toggleDeleteModal">Ta bort kompetens</button>
                    </div>
                </div>
                <div data-size="sm:12 md:5 lg:5" class="o-grid__column">
                    <div class="t-text-align-right">
                        <button v-if="mode === 'create'" type="button" class="c-button c-button--linkstyle c-button--reset" @click.prevent="cancelCreateCompetence">Avbryt</button>
                        <button v-if="mode === 'create'" type="submit" class="c-button c-button--primary" @click="setSubmitType('create')">Spara</button>
                        <button v-if="mode === 'edit'" type="button" class="c-button c-button--linkstyle c-button--reset" @click.prevent="cancelEditCompetence">Avbryt</button>
                        <button v-if="mode === 'edit'" type="submit" class="c-button c-button--primary" @click="setSubmitType('edit')">Spara</button>
                    </div>
                </div>
            </div>
        </fieldset>

        <modal :show="showLevelsModal" @closeModal="toggleLevelsModal">
            <div class="c-modal__content t-background-white s-text">
                <h1>Information om nivåer</h1>
                <table>
                    <tr>
                        <td><b>Bas</b></td>
                        <td>Är inte mångsidig, löser sällan problem själv. Liten erfarenhet av arbetsuppgifterna, arbetar inte ensam.</td>
                    </tr>
                    <tr>
                        <td><b>God</b></td>
                        <td>Är inte så mångsidig, löser dock oftast problemen själv. Har erfarenhet av arbetsuppgifterna. Kan arbeta självständigt men utmärker sig inte.</td>
                    </tr>
                    <tr>
                        <td><b>Hög</b></td>
                        <td>Är mångsidig, löser problem själv utöver det normala. Har stor erfarenhet av arbetsuppgifterna.</td>
                    </tr>
                    <tr>
                        <td><b>Spets</b></td>
                        <td>Är mycket mångsidig, löser problem åt kunden som bidrar väsentligt till företagets utveckling och resultat i positiv riktning. Är en nyckelperson i företaget med sin erfarenhet.</td>
                    </tr>
                </table>
                <div class="t-text-align-center">
                    <button type="button" class="c-button c-button--linkstyle c-button--reset t-margin-top-s" @click="toggleLevelsModal">Stäng</button>
                </div>
            </div>
        </modal>

        <modal :show="showDeleteModal" @closeModal="toggleDeleteModal">
            <div class="c-modal__content t-background-white t-text-align-center">
                <h1 class="t-text-style-alpha t-margin-bottom-s">Du tar nu bort kompetensen <span v-if="competence">"{{competence.name}}"</span></h1>
                <form @submit.prevent="handleSubmit" class="c-form">
                    <button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleDeleteModal">Avbryt</button>
                    <button type="submit" class="c-button c-button--primary t-margin-top-m" @click="setSubmitType('delete')">Ta bort</button>
                </form>
            </div>
        </modal>
    </form>
</div>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
import DropdownVariations from '@/components/vue-components/dropdown-variations/DropdownVariations.vue';
export default {
    name: 'CompetenceCardCompetence',
    components: {
        VueInput,
        Modal,
        DropdownVariations,
        VueIcon
    },
    props: ['competenceCardId', 'id', 'name', 'category', 'level', 'note', 'mode', 'printOption', 'competenceOptions', 'competenceLevelOptions'],
	data() {
		return {
			showDeleteModal: false,
			showLevelsModal: false
		}
	},
    methods: {
        setSubmitType(type) {
            this.submitType = type;
        },
        handleSubmit() {
            switch (this.submitType) {
                case 'create':
                    this.create();
                    break;
                case 'edit':
                    this.edit();
                    break;
                case 'delete':
                    this.delete();
                    break;
            }
        },
        create() {
            this.$emit('createCompetence', {
                competenceCardId: this.competenceCardId,
                competence: this.$refs.competence.getValue(),
                level: this.$refs.level.getValue().name,
                note: this.$refs.note.getValue(),
                printOption: (this.$refs.printOption.getValue()) ? 'Display' : 'Hide'
            });
            this.cancelCreateCompetence();
        },
        edit() {
            this.$emit('editCompetence', {
                competenceCardId: this.competenceCardId,
                competenceId: this.id,
                level: this.$refs.level.getValue().name,
                note: this.$refs.note.getValue(),
                printOption: (this.$refs.printOption.getValue()) ? 'Display' : 'Hide'
            });
            this.cancelEditCompetence();
        },
        delete() {
            this.$emit('deleteCompetence', {
                competenceCardId: this.competenceCardId,
                competenceId: this.id
            });
            this.toggleDeleteModal();
        },
        cancelEditCompetence() {
            this.$emit('cancelEditCompetence', this.id);
        },
        toggleDeleteModal() {
            this.showDeleteModal = !this.showDeleteModal;
        },
        toggleLevelsModal() {
            this.showLevelsModal = !this.showLevelsModal;
        },
        cancelCreateCompetence() {
            this.$emit('cancelCreateCompetence', this.id);
        },
    },
}
</script>
